import { FormState, Select } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { SubscriptionCycleOperators } from 'typings'
import { messages } from '../../messages'

type Props = {
  name: string
  form: FormState
  onChange: (event: React.FormEvent<HTMLSelectElement>) => void
}

export function CycleSelector(props: Props) {
  const { name, form, onChange } = props

  const { $t } = useIntl()

  return (
    <Select name={`${name}.operator`} onChangeCapture={onChange} state={form}>
      {Object.values(SubscriptionCycleOperators).map((value) => (
        <option key={value} value={value}>
          {$t(messages.editor.cycle.operator[value])}
        </option>
      ))}
    </Select>
  )
}
